import axios from 'axios';
import EventBus from './components/EventBus.js'
var GapiModule = {};

var requestGoogleToken = function(callback) {
  axios({
    method: 'GET',
    url: process.env.VUE_APP_AUTH_API + '/token',
    headers: {"Access-Control-Allow-Origin": "*"}
  }).then(callback);
}

var createEvent = function(start, end, userEmail, firstName, description) {
  return {
    'summary': firstName + ' <> Symbium',
    'description': description || 'Meeting with Symbium to provide new services for your jurisdiction.',
    'start': {
      'dateTime': start,
      'timezone': 'America/Los_Angeles',
    },
    'end': {
      'dateTime': end,
      'timezone': 'America/Los_Angeles',
    },
    'attendees': [
      {'email': process.env.VUE_APP_SALE_TEAM_EMAIL, 'organizer': true },
      {'email': userEmail }
    ],
    conferenceData: {
      createRequest: {
       requestId: Math.random().toString(36).substring(2)
      }
    }
  }
};

GapiModule.install = function(Vue) {
  Vue.prototype.$createGoogleCalendarEvent = function(start, end, firstName, userEmail, callback, errorCallback, description) {
    requestGoogleToken(function(response) {
      var token = response.data.token;
      window.gapi.client.setToken({ access_token: token });
      var request = window.gapi.client.calendar.events.insert({
        'calendarId': process.env.VUE_APP_SALE_TEAM_CALENDAR_ID,
        'resource': createEvent(start, end, userEmail, firstName, description),
        conferenceDataVersion: 1,
        sendUpdates: 'all',
      });
      request.execute(function(event) {
        if(event.error) {
          errorCallback();
          return;
        }
        callback(event);
      });
    });
  }
  Vue.prototype.$getGoogleCalendarEvents = function(start, end, callback) {
    requestGoogleToken(function(response) {
      var token = response.data.token;
      var calendarId = process.env.VUE_APP_SALE_TEAM_CALENDAR_ID;
      function waitUntilGapiIsLoaded() {
        if (window.gapi && window.gapi.client && window.gapi.client.calendar && window.gapi.client.calendar.events) {
          window.gapi.client.setToken({ access_token: token });
          var request = window.gapi.client.calendar.events.list({
            calendarId: calendarId,
            timeMax: end,
            timeMin: start,
          });
          EventBus.$emit('google-api-start-loading')
          request.execute(function(data) {
            callback(data)
            EventBus.$emit('google-api-finish-loading')
          });
        }
        else {
          window.setTimeout(waitUntilGapiIsLoaded, 1000);
        }
      }
      waitUntilGapiIsLoaded();
    });
  }
};

export default GapiModule;
